import * as React from 'react';

import { withStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';

const styles = (theme:any) => ({

    input: {
        border: '3px solid white',
        borderRadius: '5px',
        color: 'white',
        fontSize: '38pt',
        padding: '15px',
    }
});

interface IJoinComponentProps {
    classes:any;
    history: {
        push:  (route:string) => void;
    }
};

interface IJoinComponentState {
    team:string
};

class JoinComponent extends React.Component<IJoinComponentProps, IJoinComponentState> {

    constructor(props:IJoinComponentProps) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    public onSubmit(event:React.FormEvent) {
        event.preventDefault();
        this.props.history.push(`/${this.state.team}`);
    }

    public onChange(event:any) {
        const team = event.target.value;
        this.setState({...this.state, team});
    }

    public render() {
        const { classes } = this.props;
        return(
            <div style={{alignSelf: 'center', flexGrow: 1}}>
                <form noValidate={ true } autoComplete="off" onSubmit={ this.onSubmit }>
                <TextField
                    InputProps={{
                        className: classes.input,
                    }}
                    autoFocus={ true }
                    onChange={ this.onChange }
                    type="text"
                    name="team"
                    margin="normal"
                    placeholder="Teamname"
                />
                </form>
            </div>
       );
    }
};

export default withStyles(styles)(JoinComponent);



// WEBPACK FOOTER //
// ./src/components/JoinComponent.tsx